import { useEffect, useState } from 'react';
import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import { FILTERS } from './status';
import s from './FilterSheet.module.css';

export type ExFilters = { type?: string; responsibility?: string; stockImpact?: string };
export const FILTER_KEYS = ['type', 'responsibility', 'stockImpact'] as const;

/**
 * 更多筛选：手机是全高底部 sheet，iPad / 桌面是右侧 400 抽屉（文档 23 §6）。
 * 每组单选（老接口每个参数只收一个值）。Esc / 点遮罩关闭。
 */
export function FilterSheet({ value, onApply, onClose, sheet }: { value: ExFilters; onApply: (f: ExFilters) => void; onClose: () => void; sheet: boolean }) {
  const [f, setF] = useState<ExFilters>(value);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  const picked = FILTER_KEYS.filter((k) => f[k]).length;
  return (
    <div className={s.scrim} onClick={onClose}>
      <aside className={sheet ? s.sheet : s.drawer} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="筛选异常">
        {sheet && <div className={s.grab} />}
        <header className={s.hd}>
          <button className={s.x} onClick={onClose} aria-label="关闭"><Icon name="x" size={20} /></button>
          <b>筛选</b>
          <button className={s.reset} onClick={() => setF({})}>重置</button>
        </header>
        <div className={s.bd}>
          {FILTERS.map((g) => (
            <section key={g.key} className={s.sec}>
              <h4>{g.title}{f[g.key] && <span>已选 1</span>}</h4>
              <div className={s.chips}>
                {g.opts.map((o) => (
                  <button
                    key={o.value}
                    className={`${s.chip} ${f[g.key] === o.value ? s.on : ''}`}
                    aria-pressed={f[g.key] === o.value}
                    onClick={() => setF({ ...f, [g.key]: f[g.key] === o.value ? undefined : o.value })}
                  >
                    {o.label}
                  </button>
                ))}
              </div>
            </section>
          ))}
          <p className={s.hint}>状态在上方视图里切换；按登记日期筛选需要后端支持，暂不提供。</p>
        </div>
        <footer className={s.ft}>
          <Button variant="primary" size="lg" block onClick={() => onApply(f)}>应用{picked ? `（${picked} 项）` : ''}</Button>
        </footer>
      </aside>
    </div>
  );
}
